export type DatasetNameValidationResult = {
  valid: boolean
  errorKey?: string
}

export const validateDatasetName = (
  name: string
): DatasetNameValidationResult => {
  if (!name) {
    return { valid: true }
  }

  if (name.trim().length === 0) {
    return {
      valid: false,
      errorKey: 'Dataset name cannot contains only spaces',
    }
  }

  if (name !== name.trim()) {
    return {
      valid: false,
      errorKey: 'Dataset name cannot start or end with spaces',
    }
  }

  return { valid: true }
}
